import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { AUTH_URL } from 'src/constants/global'

interface ProfileExtrasResponse {
  analytics: {
    propertyIds: string[]
  }
}

export const useProfileExtras = (): ProfileExtrasResponse =>
  useFetch<ProfileExtrasResponse>(AUTH_URL + '/auth/profile')
